import { render, staticRenderFns } from "./c_home_video.vue?vue&type=template&id=a6a4cba6&scoped=true"
import script from "./c_home_video.vue?vue&type=script&lang=js"
export * from "./c_home_video.vue?vue&type=script&lang=js"
import style0 from "./c_home_video.vue?vue&type=style&index=0&id=a6a4cba6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a4cba6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a4cba6')) {
      api.createRecord('a6a4cba6', component.options)
    } else {
      api.reload('a6a4cba6', component.options)
    }
    module.hot.accept("./c_home_video.vue?vue&type=template&id=a6a4cba6&scoped=true", function () {
      api.rerender('a6a4cba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_video.vue"
export default component.exports